<div *ngIf="isLoading | async" class="overlay">
	<mat-progress-spinner class="spinner" [color]="color" [mode]="mode" [value]="value"> </mat-progress-spinner>
</div>
